/**
 * Created by pajicv on 10/7/18.
 */
import React from 'react';
import { connect } from 'react-redux';
import { Avatar, TextField, withStyles, Typography, Button, Card, CardContent, Icon } from '@material-ui/core';
import MemberToolbar from './InviteBar';
import { assignSubTaskToMember, updateSubTask, addUserToProject, assignWithoutNot, deleteSubTask, getWorkerDocument, updateDocumentDescription, updateDocumentTags, removeDocumentFromSubTask, } from '../../firebase/db';
import Tooltip from '@material-ui/core/Tooltip';
import Upload from '@material-ui/icons/CloudUpload';
import Dropzone from 'react-dropzone';
import CheckIcon from '@material-ui/icons/CheckOutlined'
import DocumentTags from '../common/DocumentTags';
import Download from '@material-ui/icons/CloudDownload';
import { db } from '../../firebase/firebase';
import { downloadDoc, sendEmail } from '../../firebase/functions';
import { Base64 } from 'js-base64';
import LoadingProgress from '../common/LoadingProgress';
import classNames from 'classnames';
import { removeTag } from '../../firebase/db';
import _ from 'lodash';
import saveAs from 'file-saver';
import { MAIN_COLOR, FIREBASE_PROJECT_ID, APP_URL } from '../../firebase-config';
import { toast } from 'react-toastify';
import validator from 'validator';
import swal from 'sweetalert2';
const styles = theme => ({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
        flexDirection: 'column',
        width: '92%',
        padding: 30,
        borderRadius: 50
    },
    avatars: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        //minWidth: 300,
        width: 300
    },
    avatar: {
        marginLeft: 20
    },
    invite: {
        display: 'flex',
        flexDirection: 'column',
        width: 300,
    },
    membersLine: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        height: 70,
        flex: 1,
        marginBottom: 10
    },
    infoLine: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        height: 250,
        width: '100%',
        flex: 1
    },
    dates: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 20,
        //minWidth: 300,
        width: 340,
    },
    dateField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
        flex: 1
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        paddingBottom: 20,
        width: 200,
        flex: 1
    },
    documentContainer: {
        width: 150,
        height: 100,
    },
    notesContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        width: 380
    },

    documentCard: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center'
    },
    deleteSubTaskButton: {
        right: 14,
        position: 'absolute',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    uploadDoc: {
        display: 'flex',
        flexWrap: 'wrap',
        // marginTop: 40,
        width: 230,
        paddingLeft: 187,
        alignItems: 'center',
        flexDirection: 'row',
    },
    addButton: {
        width: 40,
        height: 20,
        marginTop: 10
    },
    card: {
        margin: 15,
        width: 150,
        height: 150,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        alignContent: 'flex-start'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    button: {
        margin: 10
    },
    documents: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    textName: {
        fontSize: 12,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        width: 130,
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
    },
    documentCardContainer: {
        paddingLeft: 185,
        position: 'relative',
    },
    deleteButton: {
        position: 'absolute',
        bottom: -5,
        left: -5,
        width: 40,
        height: 40,
        zIndex: 1001
    },
    addTags: {
        position: 'absolute',
        bottom: -5,
        right: -5,
        width: 40,
        height: 40,
        zIndex: 1001
    },
    text: {
        padding: 15
    },
    extension: {
        margin: 30
    },
    input: {
        textAlign: 'left'
    },

});

class ManagerSubTask extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            notes: props.notes,
            startDate: props.startDate || (new Date()).toDateString().substr(0, 10),
            endDate: props.endDate || (new Date()).toDateString().substr(0, 10),
            finishedDate: props.finishedDate,
            subTaskName: props.name,
            role: 'worker',
            email: '',
            popup: false,
            document: null,
            documentId: null,
            name: '',
            workerNotes: props.workerNotes
        };
    }

    componentDidMount() {
        const { subTaskId } = this.props;
        db.ref('documents').limitToLast(1).on('child_added', () => {
            getWorkerDocument(subTaskId)
                .then((document) => {
                    if (!!document && document[Object.keys(document)[0]].active === true) {
                        let documment = document[Object.keys(document)[0]];
                        let documentId = Object.keys(document)[0];
                        this.setState({ document: documment, documentId: documentId })
                    }
                    else {
                        this.setState({ document: null, documentId: null })
                    }
                })
        });
        db.ref('documents').limitToLast(1).on('child_changed', () => {
            getWorkerDocument(subTaskId)
                .then((document) => {
                    if (!!document && document[Object.keys(document)[0]].active === true) {
                        let documment = document[Object.keys(document)[0]];
                        let documentId = Object.keys(document)[0];
                        this.setState({ document: documment, documentId: documentId })
                    }
                    else {
                        this.setState({ document: null, documentId: null })
                    }
                })
        });
        db.ref('documents').on('child_removed', () => {
            this.setState({ document: null, documentId: null })
        });
    }

    handleTextFieldChange = (field, value) => {
        this.setState({ [field]: value });
    };

    handleMemberDoubleClick = (memberId, assignedTo) => {
        const { subTaskId, taskName, subTaskAssigned } = this.props;
        subTaskAssigned(subTaskId);
        if (memberId === assignedTo) {
            assignWithoutNot(subTaskId, memberId, taskName);
        } else {
            assignSubTaskToMember(subTaskId, memberId, taskName);
        }
    };

    handleSubTaskNameBlur = () => {
        const { subTaskId } = this.props;
        const { subTaskName } = this.state;
        updateSubTask(subTaskId, 'name', subTaskName);
    }

    handleStartDateBlur = () => {
        const { subTaskId } = this.props;
        const { startDate } = this.state;
        updateSubTask(subTaskId, 'startDate', startDate);
    };

    handleEndDateBlur = () => {
        const { subTaskId } = this.props;
        const { endDate } = this.state;
        updateSubTask(subTaskId, 'endDate', endDate);
    };

    handleNotesBlur = () => {
        const { subTaskId } = this.props;
        const { notes } = this.state;
        updateSubTask(subTaskId, 'notes', notes);
    };

    handleWorkerNotesBlur = () => {
        const { subTaskId } = this.props;
        const { workerNotes } = this.state;
        updateSubTask(subTaskId, 'workerNotes', workerNotes);
    }

    showDescription = () => {
        this.setState({ popup: !this.state.popup });
        this.props.onTagsOpen(!this.state.popup);
    }

    onCancelDialog = () => {
        this.setState({ popup: false });
        this.props.onTagsOpen(false);
    }


    handleInviteClick = () => {
        const { projectId, auth, members } = this.props;
        const { role, email } = this.state;
        if (members[window.btoa(email)]) {
            toast.error("Team Mitglied bereits vorhanden!", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                autoClose: 2000,
            });
        }
        else {
            if (validator.isEmpty(role) || validator.isEmpty(email) || !validator.isEmail(email)) {
                toast.error("Sie müssen eine gültige E-Mail-Adresse eingeben!", {
                    position: "top-center",
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    autoClose: 2000,
                });
                return;
            }
            sendEmail({
                from: auth.email,
                to: email,
                subject: 'Invitation to project',
                html: `<p>
                     You have been invited by ${auth.email} to the project. <br/> 
                     You can access the project at <a href="${APP_URL}">${APP_URL}</a>
                   </p>`
            })
                .then(() => {
                    return addUserToProject(projectId, email, role);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    handleSubTaskDelete = () => {
        const { subTaskId, taskName } = this.props;
        const { subTaskName } = this.state;
        let name;
        if (subTaskName !== '') {
            name = subTaskName
        } else {
            name = taskName;
        }
        swal({
            title: `Wollen Sie wirklich den Task ${name} wirklich löschen?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#54be89',
            cancelButtonColor: '#ef6920',
            confirmButtonText: 'OK',
            cancelButtonText: 'CANCEL'
        }).then((result) => {
            if (result.value) {
                deleteSubTask(subTaskId)
                    .then(() => {
                        return swal(
                            'Deleted!',
                            'success'
                        )
                    })
                    .catch(console.log);
            }
        });
    };

    handleTextFieldChangeDoc = (propertyName, field, value) => {
        this.setState((state) => {
            const property = state[propertyName];
            property[field] = value;
            return { ...state, property };
        });
    };

    removeDocumentFromSubTask = (name) => {
        const { subTaskId } = this.props;
        swal({
            title: `Wollen Sie das Dokument ${name} wirklich löschen?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#54be89',
            cancelButtonColor: '#ef6920',
            confirmButtonText: 'OK',
            cancelButtonText: 'CANCEL'
        }).then((result) => {
            if (result.value) {
                removeDocumentFromSubTask(subTaskId, this.state.documentId)
                    .then(() => {
                        this.setState({
                            document: null,
                            documentId: null,
                        })
                        return swal(
                            'Deleted!',
                            'The document has been deleted.',
                            'success'
                        )
                    })
                    .catch(console.log);
            }
        });
    }

    sendTags = (tags) => {
        if (Array.isArray(this.state.document['tags'])) {
            let diff = _.difference(this.state.document['tags'], tags);
            diff.map((tag) => {
                removeTag(this.state.documentId, tag);
            })
        } else {
            let diff2 = _.difference(Object.keys(this.state.document['tags']), tags);
            diff2.map((tag) => {
                removeTag(this.state.documentId, tag);
            })
        }
        this.setState((state) => {
            const property = state.document;
            property['tags'] = tags;
            return { ...state, property };
        }, function () {
            if (Array.isArray(this.state.document.tags)) {
                this.state.document.tags.forEach((tag) => {
                    updateDocumentTags(this.state.documentId, tag);
                })
            } else {
                Object.keys(this.state.document.tags).map((key) => {
                    return updateDocumentTags(this.state.documentId, key)
                })
            }
        })
    }

    onCloseDescription = () => {
        this.setState({ popup: false });
        this.props.onTagsOpen(false);
    }

    downloadDocument = (filename, filePath) => {
        downloadDoc(filename, filePath)
            .then((response) => {
                saveAs(new Blob([response.data]), filename);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    renderDocument = () => {
        const { props: { document, docName, finished, classes } } = this;
        if (!finished) {
            return null;
        }
        return (
            <Card className={classes.documentContainer}>
                <CardContent className={classes.documentCard}>
                    <Button
                        className={classes.button}
                        color="primary"
                        variant="contained"
                        aria-label="Download"
                        onClick={() => this.downloadDocument(docName, `documents/${document}/${docName}`)}
                    >
                        <Typography>Download</Typography>
                    </Button>
                </CardContent>
            </Card>
        );
    };

    renderMembers = () => {
        const { props: { members, assignedTo, auth, classes } } = this;
        return Object.keys(members).map((memberId) => {
            const memberEmail = Base64.decode(memberId);
            const member = members[memberId];
            let radius = 40;
            if (memberId === assignedTo) {
                radius = 60;
            }
            const avatar = member.photoUri
                ? (<Tooltip title={memberEmail}>
                    <Avatar
                        style={{ width: radius, height: radius }}
                        src={member.photoUri}
                        className={classes.avatar}
                        onDoubleClick={() => this.handleMemberDoubleClick(memberId, assignedTo)}
                    />
                </Tooltip>
                ) : (
                    <Tooltip title={memberEmail}>
                        <Avatar
                            style={{ backgroundColor: MAIN_COLOR, width: radius, height: radius }}
                            className={classes.avatar}
                            onDoubleClick={() => this.handleMemberDoubleClick(memberId, assignedTo)}
                        >
                            {memberEmail.substring(0, 2).toUpperCase()}
                        </Avatar>
                    </Tooltip>
                );
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    {avatar}
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {assignedTo === memberId &&
                            < CheckIcon style={{
                                color: 'white', borderRadius: 40,
                                backgroundColor: 'gray',
                                marginLeft: 15,
                                borderStyle: 'solid',
                                borderWidth: 1,
                                borderColor: '#ccc',
                            }} />
                        }
                        {(memberEmail === auth.email) && <Typography style={{ fontSize: 18, fontWeight: 'bold', marginLeft: 15 }}>Ich</Typography>}
                    </div>
                </div>
            )
        })
    };

    handleNotesFieldChange = (field, value) => {
        this.setState({ [field]: value });
    };

    handleDropPicture = ({ accepted, rejected }) => {
        const { handleAddDocuments } = this.props;
        if (rejected.length > 0) {
            toast.error("Unsuported file type or file too large!", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (!!accepted && accepted.length !== 0) {
            handleAddDocuments(accepted[0]);
        }
    }

    renderColor = () => {
        const { assignedTo, finished } = this.props;
        if (assignedTo && !finished) {
            return '10px solid #ffff00'
        } else if (assignedTo && finished) {
            return '10px solid green'
        } else {
            return '10px solid gray'
        }

    }

    componentWillUnmount() {
        const { subTaskId } = this.props;
        if (this.state.notes !== this.props.notes) {
            updateSubTask(subTaskId, 'notes', this.state.notes);
        }
        if (this.state.workerNotes !== this.props.workerNotes) {
            updateSubTask(subTaskId, 'workerNotes', this.state.workerNotes);
        }
    }

    render() {
        const { members, classes, assignedTo, taskName, subTasks, auth, finished, index } = this.props;
        const { role, name, email, notes, startDate, endDate, finishedDate, workerNotes, subTaskName } = this.state;
        if (Object.keys(subTasks).length === 0) {
            return <LoadingProgress />
        }
        console.log('index', index);
        let iconName = 'file';
        if (this.state.document) {
            switch (this.state.document.name.split('.').pop().toLowerCase()) {
                case 'jpg': case 'jpeg': case 'bpm': case 'tiff': case 'gif': case 'png': case 'svg':
                    iconName = 'file-image';
                    break;
                case 'pdf':
                    iconName = 'file-pdf';
                    break;
                case 'zip':
                    iconName = 'file-archive';
                    break;
                case 'doc': case 'docx': case 'odt':
                    iconName = 'file-word';
                    break;
                case 'xls': case 'xlsx': case 'csv':
                    iconName = 'file-excel';
                    break;
            }
        }
        return (
            <div className={classes.container}>
                <div className={classes.deleteSubTaskButton} onClick={this.handleSubTaskDelete}>
                    <Typography color="primary" variant="subheading">Task löschen</Typography>
                    <img
                        src={FIREBASE_PROJECT_ID === 'uxs-autumn' ? require('../../icons/trash-red.svg') : require('../../icons/trash-blue.svg')}
                        height="25"
                        width="25"
                        alt="Delete"
                    />
                </div>
                {index > 0 &&
                    <div>
                        <TextField
                            margin="normal"
                            value={subTaskName}
                            className={classes.textField}
                            onChange={(e) => this.handleTextFieldChange('subTaskName', e.target.value)}
                            onBlur={this.handleSubTaskNameBlur}
                            inputProps={{
                                className: classes.input
                            }}
                            placeholder="Define subtask title"
                        />
                    </div>
                }
                <div className={classes.dates}>
                    <div style={{ borderLeft: this.renderColor() }}>
                        <TextField
                            id="startDate"
                            label="Start"
                            type="date"
                            value={startDate}
                            className={classes.dateField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => this.handleTextFieldChange('startDate', e.target.value)}
                            onBlur={this.handleStartDateBlur}
                        />
                        <TextField
                            id="endDate"
                            label="Ende"
                            type="date"
                            value={endDate}
                            className={classes.dateField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => this.handleTextFieldChange('endDate', e.target.value)}
                            onBlur={this.handleEndDateBlur}
                        />
                        {finished &&
                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                <Typography>erledigt am:</Typography>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Typography style={{ color: 'green' }}>{finishedDate && new Date(finishedDate).toLocaleDateString('de-AT')}</Typography>
                                    <CheckIcon style={{
                                        color: 'white', borderRadius: 40,
                                        backgroundColor: 'green',
                                        borderStyle: 'solid',
                                        borderWidth: 1,
                                        borderColor: '#ccc',
                                    }} />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <Typography variant="title">Zugewiesen an</Typography>
                <div className={classes.membersLine}>
                    <div className={classes.avatars}>
                        {
                            this.renderMembers()
                        }
                    </div>
                    <div className={classes.documents}>
                        <div className={classes.documents}>
                            {this.state.document &&
                                <div className={classes.documentCardContainer}>
                                    <Typography style={{ marginLeft: '15px' }}>Fertiges Dokument</Typography>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <Icon
                                                className={classNames(classes.icon, `fa fa-${iconName}`)}
                                                color="primary"
                                                fontSize="large"
                                            />
                                            <div className={classes.textName} >
                                                {this.state.document.name}
                                            </div>
                                            <div className={classes.textName} >
                                                {'Upload' + ': ' + (new Date(this.state.document.uploadDate)).toLocaleDateString('de-AT')}
                                            </div>
                                            <div style={{ backgroundColor: '#c5c2c2', height: '40px', width: '150px', display: 'flex', flexDirection: 'row', marginLeft: '-24px', marginTop: '26px', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <div style={{ cursor: 'pointer', color: 'white', marginLeft: '10px' }}
                                                    onClick={() => this.removeDocumentFromSubTask(this.state.document.name)}
                                                >
                                                    <img src={require('../../icons/trash.svg')} height="20" width="20" />
                                                </div>
                                                <div style={{ cursor: 'pointer' }}
                                                    onClick={() => this.showDescription()}
                                                >
                                                    <img src={require('../../icons/ribbon.svg')} height="20" width="20" />
                                                </div>
                                                <div style={{ cursor: 'pointer', marginRight: '10px' }}
                                                    onClick={() => this.downloadDocument(this.state.document.name, `documents/${this.state.documentId + '/' + this.state.document.name}`)}
                                                >
                                                    <Download />
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>
                            }
                        </div>
                        {!this.state.document &&
                            <div>
                                {assignedTo === window.btoa(auth.email) &&
                                    <div className={classes.uploadDoc}>
                                        <Dropzone
                                            accept={['image/tiff', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                                'application/pdf', 'text/csv', 'application/zip', 'audio/*', '.ppt', '.pptx']}
                                            maxSize={10485760}
                                            className="dropZone-profile"
                                            multiple={false}
                                            onDrop={(accepted, rejected) => this.handleDropPicture({ accepted, rejected })}
                                        >
                                            {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
                                                return <Button
                                                    variant="fab"
                                                    color="primary"
                                                    aria-label="Add"
                                                >
                                                    <Upload />
                                                </Button>
                                            }}
                                        </Dropzone>
                                        <Typography className={classes.text}>Upload {taskName}</Typography>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div style={{ marginBottom: 50, marginTop: 10 }}>Mit Doppelklick zuweisen</div>
                <div className={classes.infoLine}>
                    <div className={classes.invite}>
                        <Typography>Mitglied einladen</Typography>
                        <MemberToolbar
                            role={role}
                            name={name}
                            email={email}
                            onRoleChange={(e) => this.handleTextFieldChange('role', e.target.value)}
                            onNameChange={(e) => this.handleTextFieldChange('name', e.target.value)}
                            onEmailChange={(e) => this.handleTextFieldChange('email', e.target.value)}
                        />
                        <Button onClick={this.handleInviteClick} variant="contained" style={{ height: 40, width: 150, alignSelf: 'flex-end' }} color="primary">
                            EINLADEN
                        </Button>
                    </div>
                    {this.state.popup &&
                        <DocumentTags
                            visible={this.state.popup}
                            tags={this.state.document.tags}
                            description={this.state.document.description}
                            onCancel={this.onCancelDialog}
                            onTagsChange={(tags) => this.sendTags(tags)}
                            onDescriptionChange={(e) => this.handleTextFieldChangeDoc('document', 'description', e.target.value)}
                            onDescriptionBlur={(e) => updateDocumentDescription(this.state.documentId, e.target.value)}
                            onConfirm={this.onCloseDescription} />
                    }
                    <div className={classes.notesContainer}>
                        <TextField
                            label="Manager Notizen"
                            multiline
                            style={{ width: '460px' }}
                            rows="7"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={notes}
                            variant="outlined"
                            onChange={(e) => this.handleTextFieldChange('notes', e.target.value)}
                            onBlur={this.handleNotesBlur}
                        />

                        <TextField
                            label="Bearbeiter Notizen"
                            multiline
                            rows="7"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            style={{ width: '460px' }}
                            margin="normal"
                            variant="outlined"
                            value={workerNotes}
                            disabled={assignedTo != window.btoa(auth.email)}
                            onChange={(e) => this.handleNotesFieldChange('workerNotes', e.target.value)}
                            onBlur={this.handleWorkerNotesBlur}
                        />
                    </div>
                </div>
            </div>
        );
    }

}

export default withStyles(styles)(
    connect(state => ({ auth: state.firebase.auth }))(ManagerSubTask)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/ManagerSubTask.js